import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Header from '../Header'
import swal from 'sweetalert'

const registerUrl = "https://zomatourl.herokuapp.com/register"

const Register = () => {
  const navigate = useNavigate();

  const [user, setUser] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',

  })

  let name, value;

  const changeHandle = (e) => {
    name = e.target.name;
    value = e.target.value;
    setUser({ ...user, [name]: value })
  }

  const clickHandle = () => {
    fetch(registerUrl, {
      method : "POST",
      headers : { "Content-Type" : "application/json" },
      body : JSON.stringify(user)
    })
    .then(res => res.json())
    .then(data => {
      console.log(data);
      swal({
        title : "Great",
        text : "Register Successfully",
        icon : "success",
        button : "Aww yiss!"
      })
      navigate('/login')
    })
    .catch(err => {
      console.log(err);
    })
  }

  return (
    <React.Fragment>
      <Header />
      <div className="container border p-3 mt-5">
        <form>
          <div className="mb-3">
            <label htmlFor="name" className="form-label">Name</label>
            <input type="text" name='name' className="form-control" id="name" onChange={changeHandle} />
          </div>

          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email address</label>
            <input type="email" name='email' className="form-control" id="email" onChange={changeHandle} />
          </div>
          <div className="mb-3">
            <label htmlFor="phone" className="form-label">Phone</label>
            <input type="text" name='phone' className="form-control" id="phone" onChange={changeHandle} />
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">Password</label>
            <input type="text" name='password' className="form-control" id="password" onChange={changeHandle} />
          </div>

          <button type="button" className="btn btn-primary" onClick={clickHandle}>Submit</button>
        </form>
      </div>
    </React.Fragment>
  )
}

export default Register